import React, { useMemo, useState } from 'react';
import DrawerDetails from '../utils/drawer';
import { Button, Box, Pagination, Typography, ListItemText, ListItem, List, Divider, Grid } from '@barracuda-internal/bds-core';
import { SmallSeverityBars } from '../utils/utility';
import { getSeverityText } from '../utils/color';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import scrollpage from '../ScanResultAdvanced/Summary.js';
// Material-UI based Vulnerabilities list with Drawer details and pagination
export default function Secure_config({ state, vulnerabilities, url, title, subtitle, isSafe }) {
  const totalCount = vulnerabilities.length;

  // determine items per page from backend if provided, otherwise default to 10
  const backendPageSize = Number(
    state?.scanResult?.data?.page_size ?? state?.scanResult?.data?.per_page ?? state?.scanResult?.data?.pageSize ?? 10
  );
  const itemsPerPage = Number.isFinite(backendPageSize) && backendPageSize > 0 ? backendPageSize : 10;
  const totalPages = Math.max(1, Math.ceil(totalCount / itemsPerPage));

  const [page, setPage] = useState(1);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selected, setSelected] = useState(null);
const allowedNames = [
  "Internet Address Records",
  "Hidden Site Discovery",
  "Address Signing Check",
  "Website History Check",
  "Server Location Check"
];
  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalCount);
  const pageItems = vulnerabilities.slice(startIndex, endIndex);

  function goto(pageNum) {
    const p = Math.max(1, Math.min(totalPages, pageNum));
    setPage(p);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>{title} ({totalCount})</Typography>
      {subtitle && (
        <Typography variant="promoCaptionSubtle" gutterBottom>{subtitle}</Typography>
      )}
      <>

        <Box sx={{ mt: 2 }}>
          {pageItems.map((v, idx) => (
            <React.Fragment key={v.id ?? `${v.title}-${startIndex + idx}`}>
              <Grid container alignItems="center"
                sx={{
                  position: 'relative',
                  boxShadow: 0,
                  borderRadius: 2,
                  mb: 1,
                  transition: 'box-shadow 0.2s, border-left-color 0.2s',
                }}
              >
                {/* Status Pill */}
                <Grid item xs={7} sx={{ display: 'flex', }}>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    px: 1,
                    py: 0.5,
                    borderRadius: 2,
                    // bgcolor: isSafe ? '#e8f5e9' : '#ffebee',
                    color: isSafe ? '#2e7d32' : '#d32f2f',
                    fontWeight: 700,
                    fontSize: '0.9rem',
                    gap: 1,
                  }}>
                    {isSafe ? <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            px: 1.2,
            py: 0.4,
            borderRadius: '10px',
            background: 'linear-gradient(180deg, #e8f5e9 0%, #d7efe0 100%)',
            color: '#2e7d32',
            fontWeight: 600,
            fontSize: '0.8rem',
            gap: 0.5,
            boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
            border: '1px solid rgba(46,125,50,0.15)',
          }}
        >
          <ShieldOutlinedIcon sx={{ fontSize: 14 }} />
          Safe
        </Box> : <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            px: 1.2,
            py: 0.4,
            borderRadius: '10px',
            background: 'linear-gradient(90deg, #ffebee 60%)',
            color: '#d32f2f',
            fontWeight: 600,
            fontSize: '0.8rem',
            gap: 0.5,
            boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
            border: '1px solid rgba(46,125,50,0.15)',
          }}
        >
          <ReportProblemRoundedIcon sx={{ fontSize: 18 }} />
          Risk
        </Box>}
                    <Typography sx={{ fontWeight: 600 }}>{v?.attack_type_title || v?.name}</Typography>
                    {/* {isSafe ? 'Safe' : 'Vulnerable'} */}
                  </Box>
                </Grid>
                {/* <ReportProblemRoundedIcon sx={{ fontSize: 18 }} /> */}
                {/* Severity Vulnerable */}
                <Grid item xs={2}>
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 0.5,
      width: '100%',
    }}
  >
    {/* Top row */}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '90%',
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        Severity: {String(getSeverityText(v.severity_level) ?? '').toLowerCase()}
      </Typography>

      {/* {isSafe && (
        
      )} */}
    </Box>

    {/* Bars row */}
    <SmallSeverityBars severity={v.severity_level} isSafe={isSafe} />
  </Box>
</Grid>

                
                {/* View Details */}
                <Grid item xs={3} sx={{ textAlign: 'right' }}>
                  <Button
                    bdsType='interactiveSubtle'
                    onClick={() => {
                      setSelected(v);
                      setDrawerOpen(true);
                    }}
                  >
                    View details
                  </Button>
                </Grid>
              </Grid>

            </React.Fragment>
          ))}
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Pagination
              itemsPerPage={itemsPerPage}
              itemsPerPageDescription="items per page"
              // itemsPerPageOptions={[
              //   10,
              //   20,
              //   50
              // ]}
              onChange={(e, p) => goto(p)}
              onClickItemsPerPage={function noRefCheck() { }}
              onClickItemsPerPageOption={function noRefCheck() { }}
              onCloseItemsPerPage={function noRefCheck() { }}
              page={page}
              totalItems={totalCount}
            />
          </Box>
        </Box>

        <DrawerDetails
          url={url}
          open={drawerOpen}
          selected={selected}
          onClose={() => { setDrawerOpen(false); setSelected(null); }}
          isSafe={isSafe}
        />
      </>
    </Box>
  );
}
